import { render } from "./SlideCards.vue?vue&type=template&id=61c01228"
import script from "./SlideCards.vue?vue&type=script&lang=js"
export * from "./SlideCards.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__